import Button from './Button';
import { ButtonVariants } from './Button';

export { ButtonVariants };
export default Button;